export const isOwnArticle = (post, expertId) => {
  return post?.group?.expert?.id === expertId;
};
